'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withIntl;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _BaseComponent2 = require('./BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _getDisplayName = require('./utils/getDisplayName');

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _isServerSide = require('./utils/isServerSide');

var _isServerSide2 = _interopRequireDefault(_isServerSide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withIntl(locale, page) {
  return function (Component) {
    var isServer = (0, _isServerSide2.default)();

    var IntlComponentWrapper = function (_BaseComponent) {
      _inherits(IntlComponentWrapper, _BaseComponent);

      _createClass(IntlComponentWrapper, null, [{
        key: 'fetchIntl',
        value: function fetchIntl(host) {
          return (0, _isomorphicFetch2.default)(host + 'lang/' + locale + '/' + page + '.json').then(function (res) {
            return res.json();
          });
        }
      }]);

      function IntlComponentWrapper(props, context) {
        _classCallCheck(this, IntlComponentWrapper);

        var _this = _possibleConstructorReturn(this, (IntlComponentWrapper.__proto__ || Object.getPrototypeOf(IntlComponentWrapper)).call(this, props, context));

        _this.state = {
          translations: isServer ? context.router.staticContext.localeData : null
        };
        return _this;
      }

      _createClass(IntlComponentWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          (0, _isomorphicFetch2.default)('/lang/' + locale + '/' + page + '.json').then(function (res) {
            if (res.status >= 400) {
              throw new Error('bad response from server');
            }
            return res.json();
          }).then(function (localeData) {
            _this2.setState({
              translations: localeData
            });
          }).catch(function (err) {
            return console.error(err);
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var children = null;

          if (this.state.translations) {
            children = _react2.default.createElement(
              _reactIntl.IntlProvider,
              { messages: this.state.translations },
              _react2.default.createElement(Component, this.props)
            );
          }

          return children;
        }
      }]);

      return IntlComponentWrapper;
    }(_BaseComponent3.default);

    IntlComponentWrapper.displayName = 'withIntl(' + (0, _getDisplayName2.default)(Component) + ')';
    ;

    return (0, _hoistNonReactStatics2.default)(IntlComponentWrapper, Component);
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/withIntl.js
// module id = pXrA
// module chunks = 4